<template>
  <div>
    <div v-if="printKey === '1'">
      <blank height="30"> </blank>
      <div class="print-title">北京市民政工业总公司职工个人信息表</div>
      <div class="print-border">
        <div class="Pprintd-cont-title">基本信息</div>
        <a-descriptions bordered size="small" :column="4">
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">姓名</div>
            <div class="printCenter">
              {{ personDetail.fullName }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">性别</div>
            <div class="printCenter">
              {{ personDetail.sex }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">身份证号码</div>
            <div class="printCenter">
              {{ personDetail.idCardNumber }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">出生年月</div>
            <div class="printCenter">
              {{
                personDetail.birthTime_s
                  ? personDetail.birthTime_s.substring(0, 8)
                  : ''
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">年龄</div>
            <div class="printCenter">{{ personDetail.age }}岁</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">民族</div>
            <div class="printCenter">
              {{ personDetail.nation }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">籍贯</div>
            <div class="printCenter">
              {{ personDetail.nativePlace }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">出生地</div>
            <div class="printCenter">
              {{ personDetail.birthplace }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">政治面貌</div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.politicalType, politicalTypeList) }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">入党时间</div>
            <div class="printCenter">
              {{
                personDetail.joinPartyTime_s
                  ? personDetail.joinPartyTime_s.substring(0, 8)
                  : ''
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">户口所在地</div>
            <div class="printCenter">
              {{ personDetail.registeredResidence }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">户口性质</div>
            <div class="printCenter">
              {{
                getByTypeName(
                  personDetail.registeredNature,
                  registeredNatureList
                )
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">健康状况</div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.healthStatus, healthStatusList) }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">联系电话</div>
            <div class="printCenter">
              {{ personDetail.phone }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">家庭地址</div>
            <div class="printCenter">
              {{ personDetail.homeAddress || '' }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
        <div class="Pprintd-cont-title">学历信息</div>
        <a-descriptions bordered size="small" :column="2">
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">全日制教育</div>
              <div class="printCenter fwLabel">学历学位</div>
            </div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.firstEducation, educationList) }}
            </div>
            <div class="printCenter">
              {{ personDetail.firstAcademicDegree || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">全日制教育</div>
              <div class="printCenter fwLabel">毕业院校系及专业</div>
            </div>
            <div class="printCenter">
              {{ personDetail.firstGraduationSchool || '' }}
            </div>
            <div class="printCenter">{{ personDetail.firstMajor || '' }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">在职教育</div>
              <div class="printCenter fwLabel">学历学位</div>
            </div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.education, educationList) }}
            </div>
            <div class="printCenter">
              {{ personDetail.academicDegree || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">在职教育</div>
              <div class="printCenter fwLabel">毕业院校系及专业</div>
            </div>
            <div class="printCenter">
              {{ personDetail.graduationSchool || '' }}
            </div>
            <div class="printCenter">{{ personDetail.major || '' }}</div>
          </a-descriptions-item>
        </a-descriptions>
        <div class="Pprintd-cont-title">工作信息</div>
        <a-descriptions bordered size="small" :column="3">
          <a-descriptions-item span="3">
            <div slot="label" class="printCenter fwLabel">所在部门</div>
            <div class="printCenter">
              {{ personDetail.organizationName || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">行政职务</div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.position, positionList) }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">任现职务时间</div>
            <div class="printCenter">
              {{ personDetail.positionTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">任现职务年限</div>
            <div class="printCenter">
              {{ personDetail.positionAge || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">职级</div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.positionLevel, positionLevelList) }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">任现职级时间</div>
            <div class="printCenter">
              {{ personDetail.positionLevelTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">任现职级年限</div>
            <div class="printCenter">
              {{ personDetail.positionLevelAge || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">技术职称</div>
            <div class="printCenter">
              {{ personDetail.technicalTitle || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">职称聘任时间</div>
            <div class="printCenter">
              {{
                personDetail.appointmentTime_s
                  ? personDetail.appointmentTime_s.substring(0, 8)
                  : ''
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label" class="printCenter fwLabel">职称获得时间</div>
            <div class="printCenter">
              {{
                personDetail.acquisitionTime_s
                  ? personDetail.acquisitionTime_s.substring(0, 8)
                  : ''
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">首次参加工作时间</div>
            <div class="printCenter">
              {{ personDetail.firstWorkTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">总工龄</div>
            <div class="printCenter">
              {{ personDetail.totalSystemAge || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">
              进入本公司机关时间
            </div>
            <div class="printCenter">
              {{ personDetail.currentOfficeSysTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">本单位工龄</div>
            <div class="printCenter">
              {{ personDetail.currentOfficeSysAge || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">进入民政系统时间</div>
            <div class="printCenter">
              {{ personDetail.civilOfficeSysTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="1.5">
            <div slot="label" class="printCenter fwLabel">
              进入本公司系统时间
            </div>
            <div class="printCenter">
              {{ personDetail.headOfficeSysTime_s || '' }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
        <div class="Pprintd-cont-title">退休信息</div>

        <a-descriptions bordered size="small" :column="4">
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">退休前职务</div>
            </div>
            {{ personDetail.retirePosition || '' }}
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">退休时间</div>
            </div>
            {{ personDetail.retireTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">退休时身份</div>
            </div>
            {{ personDetail.retireIdentity || '' }}</a-descriptions-item
          >
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">退休类别</div>
            </div>
            {{ getByTypeName(personDetail.retireType, retireTypeList) }}
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">退休人员</div>
              <div class="printCenter fwLabel">档案号</div>
            </div>
            {{ personDetail.retireNumber || '' }}</a-descriptions-item
          >
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">是否社会</div>
              <div class="printCenter fwLabel">化管理</div>
            </div>
            {{ personDetail.socialManagement || '' }}
          </a-descriptions-item>

          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">减员备注</div>
            </div>
            {{ personDetail.description || '' }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div v-if="printKey === '2'">
      <blank height="30"> </blank>
      <div class="print-border print-poths">
        <div class="print-title">个 人 履 历</div>
        <div class="haveImg">
          <div class="haveImg-left">
            <a-descriptions bordered size="small" :column="3">
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">姓名</div>
                <div class="printCenter">
                  {{ personDetail.fullName || '' }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">性别</div>
                <div class="printCenter">
                  {{ personDetail.sex || '' }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label">
                  <div class="printCenter fwLabel">出生年月</div>
                  <div class="printCenter fwLabel">(岁)</div>
                </div>
                <div class="printCenter">
                  {{ personDetail.birthTime_s || '' }}
                </div>
                <div class="printCenter">({{ personDetail.age || '' }}岁)</div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">民族</div>
                <div class="printCenter">
                  {{ personDetail.nation || '' }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">籍贯</div>
                <div class="printCenter">
                  {{ personDetail.nativePlace || '' }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">出生地</div>
                <div class="printCenter">
                  {{ personDetail.birthplace || '' }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">政治面貌</div>
                <div class="printCenter">
                  {{
                    getByTypeName(personDetail.politicalType, politicalTypeList)
                  }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">入党时间</div>
                <div class="printCenter">
                  {{
                    personDetail.joinPartyTime_s
                      ? personDetail.joinPartyTime_s.substring(0, 8)
                      : ''
                  }}
                </div>
              </a-descriptions-item>
              <a-descriptions-item>
                <div slot="label" class="printCenter fwLabel">健康状况</div>
                <div class="printCenter">
                  {{
                    getByTypeName(personDetail.healthStatus, healthStatusList)
                  }}
                </div>
              </a-descriptions-item>
            </a-descriptions>
          </div>
          <div
            class="isImg"
            :style="isPrint.printTitle == 'pdf' ? 'height:139px' : ''"
          >
            <span>照片</span>
          </div>
        </div>
        <a-descriptions
          style="margin-top: -2px; z-index: 200"
          bordered
          size="small"
          :column="2"
        >
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">技术职称</div>
            </div>
            <div class="printCenter">
              {{ personDetail.technicalTitle || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">参加工作时间</div>
            </div>
            <div class="printCenter">
              {{ personDetail.firstWorkTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">进入本单位时间</div>
            </div>
            <div class="printCenter">
              {{ personDetail.currentOfficeSysTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">总工龄</div>
            </div>
            <div class="printCenter">
              {{ personDetail.totalSystemAge || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">全日制教育</div>
              <div class="printCenter fwLabel">学历学位</div>
            </div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.firstEducation, educationList) }}
            </div>
            <div class="printCenter">
              {{ personDetail.firstAcademicDegree || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">全日制教育</div>
              <div class="printCenter fwLabel">毕业院校系及专业</div>
            </div>
            <div class="printCenter">
              {{ personDetail.firstGraduationSchool || '' }}
            </div>
            <div class="printCenter">{{ personDetail.firstMajor || '' }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">在职教育</div>
              <div class="printCenter fwLabel">学历学位</div>
            </div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.education, educationList) }}
            </div>
            <div class="printCenter">
              {{ personDetail.academicDegree || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">在职教育</div>
              <div class="printCenter fwLabel">毕业院校系及专业</div>
            </div>
            <div class="printCenter">
              {{ personDetail.graduationSchool || '' }}
            </div>
            <div class="printCenter">{{ personDetail.major || '' }}</div>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <div slot="label" class="printCenter fwLabel">现任职务</div>
            <div class="printCenter">
              <span v-if="getIsLead() != -1">
                北京市民政工业总公司{{
                  getByTypeName(personDetail.position, positionList)
                }}
              </span>
              <span v-else>
                北京市民政工业总公司{{ personDetail.organizationName || ''
                }}{{ getByTypeName(personDetail.position, positionList) }}
              </span>
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <div slot="label" class="printCenter fwLabel">任现职务时间</div>
            <div class="printCenter">
              {{ personDetail.positionTime_s || '' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <div slot="label" class="printCenter fwLabel">现任职级</div>
            <div class="printCenter">
              {{ getByTypeName(personDetail.positionLevel, positionLevelList) }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <div slot="label" class="printCenter fwLabel">任现职级时间</div>
            <div class="printCenter">
              {{ personDetail.positionLevelTime_s || '' }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions
          style="margin-top: -4px"
          bordered
          size="small"
          :column="1"
        >
          <a-descriptions-item>
            <div slot="label">
              <div class="printCenter fwLabel">履</div>
              <blank height="60"> </blank>
              <div class="printCenter fwLabel">历</div>
            </div>

            <blank height="200" style="width: 250px"> </blank>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  // 接收父组件的传值
  props: ['printKey', 'personDetail', 'isPrint'],
  computed: {
    // 公司id  区别民福民政 以及显示字段
    organizationId() {
      return this.$store.state.app.userInfo.tenantId
    },
    ...mapState({
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      educationList: (state) => state.bytype.educationList, //学历
      registeredNatureList: (state) => state.bytype.registeredNatureList, //户口性质
      healthStatusList: (state) => state.bytype.healthStatusList, //健康状况
      retireTypeList: (state) => state.bytype.retireTypeList // 退休类别
    })
  },
  data() {
    return {}
  },
  methods: {
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    //获取是否 是领导
    getIsLead() {
      //总经理、副总经理、总经理助理、党委书记、党委副书记、纪委书记、纪委副书记、工会主席
      //北京园福源物业管理有限公司党总支副书记、经理、团委书记（不是领导)；
      let IsLeadList = [
        '1300',
        '1305',
        '1310',
        '1315',
        '1320',
        '1325',
        '1330',
        '1335',
        '1340',
        '1345',
        '1350'
      ]
      let IsLead = IsLeadList.indexOf(this.personDetail.position)
      // console.log(IsLead); // IsLead为-1  不是领导
      return IsLead
    }
  }
}
</script>

<style scoped>
.print-border {
  height: auto;
  overflow: hidden;
  font-family: '宋体';
  margin: 0px 30px 20px 30px;
  background-color: #333333 !important;
}
/deep/ .ant-descriptions-view table {
  border-collapse: separate;
}
.Pprintd-cont-title {
  border: 2px solid #333333;
  border-bottom: 0;
  border-top: 0;
}
.Pprintd-cont-title:nth-child(1) {
  border: 2px solid #333333;
  border-bottom: 0;
}
/deep/ .ant-descriptions-view table tbody tr th,
/deep/ .ant-descriptions-view table tbody tr td {
  border: none !important;
  border: 0 !important;
  background: #fff;
}
/deep/ .ant-descriptions-view table tbody tr {
  border: none !important;
  border: 0 !important;
}
/* 标题限制最小宽度 防止折行 */
/deep/ .ant-descriptions-view th {
  /* min-width: 110px !important; */
}

/* 内容限制最大宽度 防止折行 */
/deep/ .ant-descriptions-view td {
  max-width: 160px !important;
  /* min-width: 100px !important; */
}

.print-poths .print-title,
.print-poths .isImg {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.print-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
// .print-scrollY::-webkit-scrollbar {
//   display: none;
// }
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  font-family: '宋体';
}
.Pprintd-cont-title {
  text-align: center;
  background-color: rgb(191, 191, 191);
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  font-size: 18px;
  // border-bottom: 3px solid #c3c3c3;
}
.printCenter {
  text-align: center;
  color: #000000;
}
.haveImg {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  // border: 1px solid #c3c3c3;
}
.haveImg-left {
  width: 87%;
}
.isImg {
  height: 136px;
  width: 13%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #333;
  border-right: 2px solid #333;
  z-index: 100;
}
.fwLabel {
  font-weight: 800;
}
</style>
<style lang="scss" scoped>
.haveImg-left {
  .ant-descriptions-view {
    border-bottom: none !important;
  }
}
.ant-descriptions-view {
  // border: none;
  border-radius: 0px !important;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheRetiree/components/retireeDetailPrintPage.vue